module.exports = __webpack_public_path__ + "img/bank-blue-one.0905fd9b.png";